<template>   
    <div class="text-center nodata flex flex-col"> 
        <img class="mb-3 icon mx-auto" src="../../../assets/icon/ep_warning.svg" />
        <span class="text-20 text-a-blue-1c3e95">{{lbl.history.nodata}}</span>
    </div>
</template>
<script> 
import LocaleMixin from '@/mixin/LocaleMixin.js';

/**
 * @event onClickPurchase
 */
export default {
    name: 'NoData',
    mixins: [LocaleMixin], 
    data: function() { 
    }, 
}
</script>
<style lang="scss" scoped>
.icon {
    width: 27px;
    height: 27px;
}
.nodata {
    padding-top: 180px;
}
</style>
